import { render, staticRenderFns } from "./SiteExpansionUpdate.vue?vue&type=template&id=2f3372c6"
import script from "./SiteExpansionUpdate.vue?vue&type=script&lang=js"
export * from "./SiteExpansionUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports